import React, { useEffect, useRef, useState } from "react";
import axiosStrapiInstance from "./axiosStrapi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import loginImg from "./assets/parentPortal.jpg";
import pinkHeart from "./assets/pinkHeart.svg";
import FlyingPlaneImg from "./assets/flyingPlane.svg";
import mobileLoginImg from "./assets/mobileParentPortalImg.jpg";

export default function Login() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [admissionNumber, setAdmissionNumber] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const navigate = useNavigate();

  const handlePhoneChange = (e) => {
    const input = e.target.value;
    const formattedInput = input.replace(/[^0-9]/g, "");
    setPhoneNumber(formattedInput);
  };

  const handleAdmissionChange = (e) => {
    const input = e.target.value;
    const formattedInput = input.replace(/[^0-9]/g, "");
    setAdmissionNumber(formattedInput);
  };

  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);

  const handleChangeOtp = (value, index) => {
    if (/[^0-9]/.test(value)) return; // Only allow numeric input
    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    if (value !== "" && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleVerify = () => {
    if (otp[5] && otp?.length === 6) {
      //make function for verify otp if otp is verified then else clear userDetails.
      localStorage.setItem("privateToken", userDetails?.token);
      localStorage.setItem("studentData", JSON.stringify(userDetails?.student));
      navigate("/dashboard");
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  async function getOtp(e) {
    e.preventDefault();
    if (!phoneNumber || !admissionNumber) {
      toast.error("Fill all the Details");
      return;
    }
    try {
      setLoading(true);
      const payload = {
        data: { phone: phoneNumber, admissionNumber: admissionNumber },
      };
      const response = await axiosStrapiInstance.post(
        "/api/student/login",
        payload,
        {
          privateToken: true,
        }
      );
      setUserDetails(response?.data);
      setOtpSent(true);
      toast.success("Otp Sent Successfully");
    } catch (error) {
      console.log("error while submiting form", error);
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      } else {
        toast.error("Login failed");
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex lg:pt-0 font-Lato lg:flex-row overflow-hidden flex-col justify-between xl:max-h-[calc(100vh-80px)] lg:max-h-[calc(100vh-0px)] bg-[rgb(249,239,240)] text-white">
      <img
        src={"/girlchild6.svg"}
        alt="girl child"
        className="top-0 right-0 sm:block hidden absolute h-[321px] w-[131px]"
      />
      <div className="lg:w-[50%] lg:h-[calc(100vh-80px)]">
        <img
          src={window.innerWidth < 450 ? mobileLoginImg : loginImg}
          alt="login Girl"
          className="h-[60vh] lg:h-full w-full"
        />
      </div>
      <div className="lg:w-[55%] relative px-[4%] sm:px-[10%] flex flex-col font-Lato items-center lg:mt-[10%] lg:pb-0 lg:pt-0 pt-10 pb-[140px]">
        <div data-svg-wrapper className="absolute  z-0 bottom-0 left-0">
          <svg
            width="563"
            height="167"
            viewBox="0 0 663 197"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M662.164 78.5142C642.504 84.5146 476.379 39.5582 451.663 83.2149C426.948 126.872 485.568 163.703 504.229 178.51C555.795 219.405 590.101 269.366 555.423 304.496C522.976 337.369 307.436 253.013 179.162 160.105C103.278 105.155 25.504 29.7403 2.15329 1.98422"
              stroke="#D31C4F"
              stroke-width="4"
              stroke-miterlimit="10"
              stroke-dasharray="8 8"
            />
          </svg>
          <img
            src={FlyingPlaneImg}
            alt="plane"
            className="absolute bottom-[62px] right-[-12%]"
          />
        </div>
        <div data-svg-wrapper className="absolute bottom-0 left-0">
          <svg
            width="633"
            height="157"
            viewBox="0 0 663 197"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            stroke-dasharray="8 8"
          ></svg>
        </div>

        {otpSent ? (
          <>
            <div className="flex flex-col items-start justify-center gap-4">
              <h1 className="text-[#d31c4f] self-start text-[42px] font-Wonderbar leading-[30px]">
                Verify your Account{" "}
                <img
                  src={pinkHeart}
                  alt="pink Heart"
                  className="ml-1 h-[50px] rotate-12 w-[50px] inline"
                />{" "}
              </h1>
              <div className="text-[#667084] self-start text-xl font-normal leading-[30px]">
                Enter the 4-digit that we have sent via the phone number +91
                813-8172-5977
              </div>
              <div className="text-[#344053] text-sm font-medium mt-5 leading-tight">
                Enter OTP
              </div>
              <div className="flex justify-between w-full space-x-4">
                {otp.map((value, index) => (
                  <input
                    key={index}
                    type="text"
                    value={value}
                    onChange={(e) => handleChangeOtp(e.target.value, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    maxLength={1}
                    ref={(ref) => (inputRefs.current[index] = ref)}
                    className="w-[20%] h-[60px] text-center text-2xl font-bold border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none  text-zinc-800"
                  />
                ))}
              </div>
              <div className="w-[364px] text-[#797979] text-sm font-medium leading-tight">
                This session will end in 02 minutes.
              </div>
              <button
                onClick={handleVerify}
                className={`h-11 w-full px-5 mt-4 py-3 ${
                  !otp[5] ? "bg-[#d31c4f]/40" : "bg-[#d31c4f]"
                }  rounded-lg shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] border border-[#d31c4f]/40 justify-center items-center gap-2 inline-flex overflow-hidden`}
              >
                <div className="text-white text-sm font-medium leading-tight">
                  Verify
                </div>
              </button>
              <div className="text-center mt-3 mx-auto">
                <span className="text-[#0c0c0d] text-sm font-medium leading-tight">
                  Didn’t receive any code?
                </span>
                <span className="text-[#d31c4f] text-sm font-semibold font-['Lato'] leading-tight">
                  {" "}
                  Resend code
                </span>
              </div>
            </div>
          </>
        ) : (
          <>
            <h1 className="text-[#d31c4f] self-start text-[30px] sm:text-[42px] font-Wonderbar leading-[30px]">
              Mother<span className="font-Lato">'</span>s Pride{" "}
              <img
                src={pinkHeart}
                alt="pink Heart"
                className="ml-1 h-[50px] w-[50px] inline"
              />{" "}
            </h1>
            <p className="text-[#667084] mt-2 text-justify text-lg font-normal leading-[30px]">
              Stay connected with your child’s journey through the Parent
              Portal. View memories, check the menu, track events & holidays all
              in one place!
            </p>
            <div className="w-full flex flex-col gap-3 mt-5">
              <div className="">
                <label
                  htmlFor="admission"
                  className="text-[#344053] pl-[2px] text-sm font-medium leading-tight"
                >
                  Admission Number
                </label>
                <input
                  id="admission"
                  type="text"
                  value={admissionNumber}
                  onChange={handleAdmissionChange}
                  placeholder="Admission Number"
                  maxLength={10}
                  className="w-full rounded-lg px-4 bg-white shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] border border-[#cfd4dc] py-2 font-normal leading-normal text-[#667084] focus:outline-none placeholder:text-[#667084]"
                />
                {admissionNumber.length === 5 && (
                  <p className="mt-2 text-green-500">Valid Admission Number</p>
                )}
                {admissionNumber.length > 0 && admissionNumber.length < 5 && (
                  <p className="mt-2 text-red-600">
                    Admission Number must be 5 digits
                  </p>
                )}
              </div>

              <div className="">
                <label
                  htmlFor="phone"
                  className="text-[#344053] pl-[2px] text-sm font-medium leading-tight"
                >
                  Phone Number
                </label>
                <input
                  id="phone"
                  type="text"
                  value={phoneNumber}
                  onChange={handlePhoneChange}
                  placeholder="Phone number"
                  maxLength={10}
                  className="w-full rounded-lg px-4 bg-white shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] border border-[#cfd4dc] py-2 font-normal leading-normal text-[#667084] focus:outline-none placeholder:text-[#667084]"
                />
                {phoneNumber.length === 10 && (
                  <p className="mt-2 text-green-500">Valid phone number</p>
                )}
                {phoneNumber.length > 0 && phoneNumber.length < 10 && (
                  <p className="mt-2 text-red-600">
                    Phone number must be 10 digits
                  </p>
                )}
              </div>
              <button
                onClick={getOtp}
                className="h-12 mt-6 px-5 z-20 py-3 bg-[#d31c4f] rounded-lg shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] border border-[#d31c4f] justify-center items-center gap-2 inline-flex overflow-hidden"
              >
                <div className="text-white text-base font-medium leading-normal">
                  Get OTP
                </div>
              </button>

              <p className="text-center mt-3">
                <span className="text-[#0c0c0d] text-sm font-medium leading-[21px]">
                  Don't have an account?{" "}
                </span>
                <span className="text-[#d31c4f] text-[13px] font-medium underline leading-[21px]">
                  Contact Admin for credentials
                </span>
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
